export const SPLIT_NAMES = {
  admin_wallet_activation: "admin_wallet_activation",
  approvalFlow: "approval_flow",
  categoryLock: "category_lock",
  billFeeRealtimeDeduction: "bill_fee_realtime_deduction",
  selfApprovalPolicy: "self_approval_policy",
  crManagePayout: "cr_manage_payout",
  analyticsFeatureFlag: "analytics_feature_flag",
  cardsTrxns: "cards_trxns",
  billNewCR: "bill_cr_v2",
  removeCardsColorSelection: "remove_card_selection",
  billPaymentRunPage: "bill_payment_run",
  paynowCRAdhoc: "cr_pay_adhoc",
  upsellingCard: "upselling_card",
};

export const SPLIT_TREATMENT_TYPES = {
  CONTROL: "control", // loading
  ON: "on",
  OFF: "off",
};
